export type { ChatMessage, RepoContext } from '../../models/orchestrator-surface.model';
export { compactChatMessages, normalizeRepoContext } from '../../models/orchestrator-surface.model';
import { extractPositionsLayout } from '../../utils/extract-positions-layout.util';

export type DbDiagramLayout = {
  positions: Record<string, { x: number; y: number }>;
};

export type DbSchemaField = {
  name: string;
  type: string;
  pk?: boolean;
  fk?: boolean;
  nullable?: boolean;
  unique?: boolean;
};

export type DbSchemaTable = { name: string; fields: DbSchemaField[] };

export type DbSchemaRelationship = {
  fromTable: string;
  fromField: string;
  toTable: string;
  toField: string;
  cardinality?: '1:1' | '1:N' | 'N:N';
  label?: string;
};

export type DbSchema = {
  tables: DbSchemaTable[];
  relationships: DbSchemaRelationship[];
};

export function extractSchema(payload: any): DbSchema | null {
  const candidate = payload?.schema && typeof payload.schema === 'object' ? payload.schema : payload;
  if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) return null;
  const tables = Array.isArray(candidate.tables) ? candidate.tables : [];
  const relationships = Array.isArray(candidate.relationships) ? candidate.relationships : [];
  return { tables, relationships } as DbSchema;
}

export function extractLayout(payload: any): DbDiagramLayout | null {
  const layout = extractPositionsLayout(payload, 'layout');
  return layout ? (layout as DbDiagramLayout) : null;
}
